<template>
  <div class="radio_wrapper">
    <label class="radiooption" v-bind:class="{ formElementError: errorMsg }" :for="inputId">
      <input
        class="mr-2"
        type="radio"
        :id="inputId"
        :name="group"
        :value="value"
        :checked="shouldBeChecked"
        @change="updateInput"
      />
      {{value}}
    </label>
    <p v-if="errorMsg" class="formErrorMsg">
      {{ errorMsg }}
    </p>
  </div>
</template>

<script>
export default {
  name: "RadioButton",
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    group: String,
    value: String,
    modelValue: String,
    errorMsg: {
      type: String,
      default: null
    }
  },
  computed: {
    shouldBeChecked() {
      return this.modelValue == this.value
    }
  },
  data() {
    return {
      inputId: "radio-" + this.group + "-" + this.value,
    };
  },
  methods: {
    updateInput() {
      this.$emit('change', this.value)
    }
  }
};
</script>